// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"bddb536a","308":"c165a5b0","787":"cb623dd8"}[chunkId] + ".chunk.js";
};